import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setConfirmAction } from 'redux/ui/actions';

const ConfirmAction = ({
  action,
  children,
  description,
  setConfirmAction,
  onClick,
  ...props
}) => (
  <span
    {...props}
    onClick={(...args) => {
      if (onClick) {
        onClick(...args);
      }
      setConfirmAction({ action, description });
    }}
  >
    {children}
  </span>
);

ConfirmAction.propTypes = {
  children: PropTypes.node.isRequired,
  description: PropTypes.string.isRequired,

  action: PropTypes.func.isRequired,
  setConfirmAction: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

ConfirmAction.defaultProps = {
  onClick: null,
};

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  setConfirmAction: payload => dispatch(setConfirmAction(payload)),
});

const wrappedConfirmAction = connect(undefined, mapDispatchToProps)(ConfirmAction);
wrappedConfirmAction.displayName = 'ConfirmAction';

export default wrappedConfirmAction;
